import React from 'react'

import { Header, Layout, SectionTitle, ItemTitle } from '../../../../components'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        exclusive={true}
        site={data.site}
        slug={data.slug + '/design/'}
        title={data.title}
        state="design"
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        title={data.title}
        state="design"
      >
        <SectionTitle>Stroke Variants</SectionTitle>
        <ItemTitle>Solid</ItemTitle>
        <p>Use to define the edge of an object with a solid line.</p>
        <table class="showcase-table l-margin-bottom--none">
          <thead>
            <th> </th>
            <th>Hex</th>
            <th>Width</th>
            <th>Class</th>
          </thead>
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-border-solid--primary"></span>
                  Green / Primary / Base
                </div>
              </td>
              <td>#007856</td>
              <td>1px</td>
              <td>
                <span class="table__code">.u-border-solid--primary</span>
              </td>
            </tr>
            <tr class="showcase-table__darker-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box transparent u-border-solid--white"></span>
                  White
                </div>
              </td>
              <td>#FFF</td>
              <td>1px</td>
              <td>
                <span class="table__code">.u-border-solid--white</span>
              </td>
            </tr>
            <tr class="showcase-table__white-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-border-solid--gray"></span>
                  Gray / Base
                </div>
              </td>
              <td>#BABABA</td>
              <td>1px</td>
              <td>
                <span class="table__code">.u-border-solid--gray</span>
              </td>
            </tr>
            <tr class="showcase-table__darker-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box transparent u-border-solid--gray-light"></span>
                  Gray / Light
                </div>
              </td>
              <td>#D7D7D7</td>
              <td>1px</td>
              <td>
                <span class="table__code">.u-border-solid--gray-light</span>
              </td>
            </tr>
            <tr class="showcase-table__white-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-border-solid--gray-lighter"></span>
                  Gray / Lighter
                </div>
              </td>
              <td>#EFEFEF</td>
              <td>1px</td>
              <td>
                <span class="table__code">.u-border-solid--gray-lighter</span>
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Dashed</ItemTitle>
        <p>Use to define the edge of an object with a dashed line.</p>
        <table class="showcase-table l-margin-bottom--none">
          <thead>
            <th> </th>
            <th>Hex</th>
            <th>Width</th>
            <th>Class</th>
          </thead>
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-border-dashed--primary"></span>
                  Green / Primary / Base
                </div>
              </td>
              <td>#007856</td>
              <td>1px</td>
              <td>
                <span class="table__code">.u-border-dashed--primary</span>
              </td>
            </tr>
            <tr class="showcase-table__darker-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box transparent u-border-dashed--gray-light"></span>
                  Gray / Light
                </div>
              </td>
              <td>#D7D7D7</td>
              <td>1px</td>
              <td>
                <span class="table__code">.u-border-dashed--gray-light</span>
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>None</ItemTitle>
        <p>Use to remove an existing stroke.</p>

        <hr />

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Dashed strokes typically communicate that an object is a placeholder,
          such as in the Upload Field pattern.
        </p>
      </Layout>
    </>
  )
}
